export const xFP = {
  RF_ADMIN: 'xF_%role_farm_admin%_Fx',
  RF_BOOK: 'xF_%role_farm_book%_Fx',
  RF_EXT: 'xF_%role_farm_ext%_Fx',
  RF_INT: 'xF_%role_farm_int%_Fx',
  RF_CONTRACTOR: 'xF_%role_farm_contractor%_Fx',
  RF_MANAGER: 'xF_%role_farm_manager%_Fx',
  RF_CONTRIBUTOR: 'xF_%role_farm_contributor%_Fx',
  RF_TECHNICAL_CONSULTANT: 'xF_%role_farm_technical_consultant%_Fx',
  RF_ONLYREAD: 'xF_%role_farm_onlyread%_Fx',
  RF_NOACCESS: 'xF_%role_farm_noaccess%_Fx',
  RF_DRIVER: 'xF_%role_farm_driver%_Fx',
  RF_AGRONOMIST: 'xF_%role_farm_agronomist%_Fx',
  RF_SUPERADMIN_XFARM: 'xF_%ROLE_XFARM_SUPER_BOSS_JHK?hj89K09#wY45%_Fx',
  RF_SUPEREDITOR_XFARM: 'xF_%ROLE_XFARM_SUPER_EDITOR_HKJ878COP?I£D4%_Fx',
  ALL_RF: [
    'xF_%role_farm_admin%_Fx',
    'xF_%role_farm_manager%_Fx',
    'xF_%role_farm_contributor%_Fx',
    'xF_%role_farm_technical_consultant%_Fx',
    'xF_%role_farm_onlyread%_Fx',
    'xF_%role_farm_noaccess%_Fx',
    'xF_%ROLE_XFARM_SUPER_BOSS_JHK?hj89K09#wY45%_Fx',
    'xF_%ROLE_XFARM_SUPER_EDITOR_HKJ878COP?I£D4%_Fx',
    'xF_%role_farm_book%_Fx',
    'xF_%role_farm_ext%_Fx',
    'xF_%role_farm_int%_Fx',
    'xF_%role_farm_contractor%_Fx',
    'xF_%role_farm_driver%_Fx',
    'xF_%role_farm_agronomist%_Fx',
  ],
};
